module.exports = __webpack_public_path__ + "95c7bf6c.svg";


//////////////////
// WEBPACK FOOTER
// ./public/SVG/icon_videollamada_espera.svg
// module id = 1155
// module chunks = 0 1 2